import React, { useContext, useEffect, useState } from 'react';
import LogContext from '../context/LogContext';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { homeScroll } from "../smoothScroll";
import FilterSidebar from './FilterSidebar';
import slugify from '../utils/slugify';
import deSlugify from '../utils/deSlugify';
import LoadingSpinner from './LoadingSpinner';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

export default function Collection() {
  const { collectionName, subCollection } = useParams();
  const myContext = useContext(LogContext);
  const [applying, setApplying] = useState(false);
  const [filter, setFilter] = useState({
    collection: [], prints: [], minPrice: 0, maxPrice: 50000
  });
  const [showFilter, setShowFilter] = useState(false);
  const [isChanging, setIsChanging] = useState(true)
  const [data, setData] = useState([]);
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();
  const products = async () => {
    if (filter.collection.length > 0 || filter.prints.length > 0 || filter.minPrice > 0 || filter.maxPrice < 50000)
      setApplying(true)
    try {
      const response = await fetch(`${backendUrl}/getProducts`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ collection: deSlugify(collectionName), category: deSlugify(subCollection), filter })
      });
      const responseData = await response.json();
      setData(responseData["data"]);
      console.log(response.data);
      if (filter.collection.length > 0 || filter.prints.length > 0 || filter.minPrice > 0 || filter.maxPrice < 50000) {
        setApplying(false);
        alert("Filter applied to Shop!")
        setShowFilter(false);
        filterPopUp();

      }
    } catch (error) {
      console.log("Some error occured", error)
    }
  };

  const addToCartHandler = async (itemID) => {
    try {
      if (!myContext.user.email) {
        navigate('/login');
      }
      else if (cart.filter(items => items.productID === itemID).length != 0) {
        // console.log("already In cart");
        return
      }
      else {
        const response = await fetch(`${backendUrl}/cartHandler`, {
          method: "POST",
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify({ "email": myContext.user.email, "itemID": itemID })
        });
        if (response.ok) {
          myContext.updateCart(itemID)
        }
      }
    } catch (error) {
      console.log("Some error occured", error)
    }
  }
  const whishlistHandler = async (productID) => {
    try {
      const response = await fetch(`${backendUrl}/addToWishlist`, {
        method: 'POST',
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ email: myContext.user.email, productID })
      });
      if (response.ok) {
        console.log("added to wishlist");
      }
      else {
        console.log("problem sending data")
      }
    }
    catch (error) {
      console.log("error Occured", error)
    }
  };
  const cartUpdate = async () => {
    try {
      const response = await fetch(`${backendUrl}/cartData`, {
        method: "POST",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify({ email: myContext.user.email })
      });
      if (response.ok) {
        const productArray = await response.json();
        setCart(productArray.cartItems);
      } else {
        console.log("Can't retrieve data from the user collections in the database");
      }
    } catch (error) {
      console.error("Error fetching cart data:");
    }
  }
  const filterPopUp = () => {
    const filter = document.getElementById('filter-dropdown');
    setIsChanging(true)
    if (showFilter) {
      filter.style.position = "fixed";
      filter.style.left = "-100rem";
      setShowFilter(false);
    } else {
      setIsChanging(false)
      filter.style.position = "fixed";
      filter.style.left = "0%";
      setShowFilter(true);
    }
  }
  useEffect(() => {
    products();
  }, [myContext.category, myContext.subcategory, filter])

  useEffect(() => {
    if (window.scrollY === 0) {
      window.scrollTo({ top: 1, behavior: 'smooth' })
    }
  }, [])
  return (
    <div className='collection'>
      <section id="new-arrivals" className="new-arrivals" style={{ marginTop: '4rem' }}>
        <div className="container">
          <div className="section-header">
            <FilterSidebar showFilter={showFilter} setShowFilter={setShowFilter} filter={filter} setFilter={setFilter} applying={applying} />
            <div className='row'>
              <div className='col-md-6'>
                <p style={{ letterSpacing: "2", textAlign: 'left', fontSize: '1.2rem' }}><Link>Home </Link> {'>'} <Link> {collectionName} </Link> {'>'} <Link> {subCollection}</Link> </p>
              </div>
              <div className='col-md-6'>
                <button className='pull-right filter-btn' onClick={() => filterPopUp()}> <i className="fa-solid fa-sliders"></i> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Filter</button>
              </div>
            </div>
          </div>
          <div className="new-arrivals-content" style={{ marginTop: '60px' }}>
            <div className="product-grid row">
              {!data.length ?
                <div style={{ position: 'relative', left: "50%", top: '-5rem' }}>
                  <LoadingSpinner />
                </div>

                :
                data.map((product, index) => (
                  <div key={product._id} className="col-sm-3 col-xs-4">
                    <div className="single-new-arrival">
                      <div className="single-new-arrival-bg">
                        <img src={`${adminUrl}/uploads/products/${product.images[0].preview}`} alt="new-arrivals images" style={{ height: '310px', width: '100%' }} />
                        <div className="single-new-arrival-bg-overlay"></div>
                        <div className="sale bg-1">
                          <p>sale</p>
                        </div>
                        <div className="new-arrival-cart">
                          <p>
                            <span className="lnr lnr-cart"></span>
                            <button onClick={(e) => { addToCartHandler(product._id) }}>add <span>to </span> cart</button>
                          </p>
                          <p className="arrival-review pull-right">
                            <span className="lnr lnr-heart" style={{ cursor: "pointer" }} onClick={() => { whishlistHandler(product.productID) }}></span>
                            <span className="lnr lnr-frame-expand"></span>
                          </p>
                        </div>
                      </div>
                      <h4><Link to={`/products/${product.title}`} onClick={(e) => { homeScroll(); localStorage.setItem('currentProduct', product.title); myContext.updateProduct(`${product.title}`) }}>{product.title}</Link></h4>
                      <p className="arrival-product-price"><span style={{ fontWeight: '500' }}>&#8377; {product.pricing.offerPrice} </span><span style={{ fontSize: '12px' }}>M.R.P <del>&#8377; {product.pricing.MRP}</del></span></p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
